import { isRecord } from './isRecord';

const decodeBase64Url = (segment: string): string | null => {
  const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');

  try {
    return atob(base64);
  } catch {
    return null;
  }
};

/**
 * Извлекает время протухания токена (`exp`) из JWT и возвращает его
 * в миллисекундах (Unix-time × 1000). Возвращает `null`, если токен
 * не является корректным JWT либо не содержит числового `exp`.
 *
 * @param token - access token (JWT)
 * @returns время протухания в миллисекундах или `null`
 */
export const getJwtExp = (token: string | null): number | null => {
  if (token === null) {
    return null;
  }

  const payloadSegment = token.split('.')[1];

  if (payloadSegment === undefined) {
    return null;
  }

  const decoded = decodeBase64Url(payloadSegment);

  if (decoded === null) {
    return null;
  }

  let payload: unknown;

  try {
    payload = JSON.parse(decoded);
  } catch {
    return null;
  }

  if (!isRecord(payload) || typeof payload.exp !== 'number') {
    return null;
  }

  return payload.exp * 1000;
};
